import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_LOGO_FULL_SRC } from '../../config/brandAssets';

const HeaderLP: React.FC = () => {
  const navLinks = [
    { href: '#for-services', label: 'Dla serwisów' },
    { href: '#for-customers', label: 'Dla klientów' },
    { href: '#jak-budujemy', label: 'Jak budujemy' },
    { href: '#kontakt', label: 'Kontakt' },
  ];
  const primaryCta =
    'inline-flex min-h-11 items-center justify-center rounded-lg border border-ratuj-300/25 bg-ratuj-300/10 px-3 py-2 text-sm font-semibold text-ratuj-200 transition-colors hover:bg-ratuj-300/15 focus-outline sm:min-h-[40px] sm:border-ratuj-400 sm:bg-ratuj-400 sm:px-4 sm:text-white sm:shadow-button sm:hover:bg-ratuj-300';
  const neutralCta =
    'inline-flex min-h-11 min-w-11 items-center justify-center whitespace-nowrap rounded-lg px-1.5 py-2 text-sm font-semibold text-primary-light-300 transition-colors hover:text-ratuj-200 focus-outline sm:min-h-[40px] sm:min-w-0 sm:border sm:border-primary-dark-300/70 sm:bg-primary-dark-100/35 sm:px-4 sm:text-primary-light-200 sm:hover:bg-primary-dark-300/70 sm:hover:text-primary-light-100';

  return (
    <header className="sticky top-0 z-50 border-b border-primary-dark-300/65 bg-primary-dark-200/94 shadow-card backdrop-blur-sm">
      <nav className="rs-page-gutter mx-auto flex max-w-7xl items-center justify-between gap-2 py-2.5 sm:gap-4 sm:py-3">
        <Link
          to="/"
          className="flex min-h-11 flex-none items-center gap-2 text-base font-bold text-primary-light-100 transition-colors hover:text-ratuj-200 focus-outline sm:min-h-0 sm:text-lg"
        >
          <img src={BRAND_LOGO_FULL_SRC} alt="" className="h-8 w-8 flex-none object-contain" />
          <span className="whitespace-nowrap">Ratuj Sprzęt</span>
        </Link>

        <div className="hidden items-center gap-6 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-lg px-1 py-2 text-sm font-medium text-primary-light-300 transition-colors hover:text-ratuj-200 focus-outline"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex min-w-0 items-center gap-1.5 sm:gap-3">
          <Link to="/login" className={neutralCta}>
            Zaloguj się
          </Link>
          <Link to="/register/service" className={primaryCta}>
            <span className="hidden sm:inline">Dołącz jako serwis</span>
            <span className="sm:hidden">Dołącz</span>
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default HeaderLP;
